import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { formatBytes } from '../../services/SandboxService';
import { planSummary } from '../../utils/workspacePageModel';

const VERBS = { start: 'Start', stop: 'Stop', sleep: 'Put to sleep', share: 'Share', remove: 'Remove', quality: 'Run the checks of' };
const DANGER = ['stop', 'sleep', 'remove'];

/**
 * The question before Start all / Stop all (the header), a bulk action of the Projects table (Start, Stop, Put to
 * sleep, Run quality, Share, Remove) or the Quality tab's Run all checks: how many projects and what happens to them, then the ones that are skipped with their reason.
 * `pending`: `{ action, plan, detail? }` or null; `detail` says what a sleep, share or remove does.
 */
export default function RunConfirm({ pending, onCancel, onConfirm }) {
  if (!pending) { return null; }
  const { action, plan, detail = '' } = pending;
  const verb = VERBS[action];
  const count = plan.eligible.length;
  const projects = `${count} project${count === 1 ? '' : 's'}`;
  return (
    <Modal
      cancelText={count ? 'Cancel' : 'Close'}
      okButtonProps={{ danger: DANGER.includes(action), style: count ? undefined : { display: 'none' } }}
      okText={`${verb} ${projects}`}
      onCancel={onCancel}
      onOk={onConfirm}
      open
      title={count ? `${verb} ${projects}?` : `Nothing to ${action === 'quality' ? 'check' : verb.toLowerCase()}`}
    >
      {count > 0 && (
        <p data-testid="run-confirm-summary">
          {action === 'start' || action === 'stop' ? planSummary(action, plan, formatBytes) : `${plan.eligible.map((entry) => entry.name).join(', ')}. ${detail}`}
        </p>
      )}
      {plan.skipped.length > 0 && (
        <>
          <p>{count > 0 ? 'Skipped:' : 'Every project is skipped:'}</p>
          <ul aria-label="Skipped projects" className="ws-skipped">
            {plan.skipped.map((entry) => <li key={entry.projectId}><strong>{entry.name}</strong>: {entry.reason}</li>)}
          </ul>
        </>
      )}
    </Modal>
  );
}

RunConfirm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  pending: PropTypes.shape({ action: PropTypes.string, detail: PropTypes.string, plan: PropTypes.object }),
};
